import { Box, Grid, Typography } from "@mui/material";
import { CheckoutState, SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect } from "react";
import { Plans } from "schemas/payments";

import BannerWrapper from "../BannerWrapper";
import { useCountDown } from "../useCountdown";

const MoneyBackGuaranteePromo = () => {
  const { display, createTimer } = useCountDown();
  const { setOpenCheckoutDialog } = useContext(SubscriptionContext);

  useEffect(() => {
    createTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openMoneyBack = () => {
    const state: CheckoutState = {
      plan: Plans.VA_YEARLY,
      source: "Money Back Guarantee Banner",
      pageSource: window.location.pathname,
    };
    setOpenCheckoutDialog(state);
  };

  return display ? (
    <BannerWrapper onClick={openMoneyBack}>
      <Grid
        container
        alignItems={"center"}
        justifyContent={"center"}
        sx={{ py: 0.5 }}
      >
        <Typography
          sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
          textAlign="center"
        >
          💸 Money-Back Guarantee — Offer Ends in <strong>{display}</strong>. If
          you don't earn more than you pay in a year, we'll refund you{" "}
          <strong>100%</strong>.
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ color: "white", ml: 1 }}
          />
        </Typography>
      </Grid>
    </BannerWrapper>
  ) : (
    <></>
  );
};

export default MoneyBackGuaranteePromo;
